import React from 'react'
import { useInView } from 'react-intersection-observer'
import { ROW_HEIGHT } from '../RowLayout'

export type LoaderProps = {
  load: () => void
  margin?: number
}

export const Loader = ({ load, margin = ROW_HEIGHT * 20 }: LoaderProps) => {
  const [ref, inView] = useInView({
    rootMargin: `${margin}px`,
    threshold: 0,
  })

  React.useEffect(
    () => {
      if (inView) {
        load()
      }
    },
    [inView, load]
  )

  return <div ref={ref} style={{ height: 1, marginBottom: -1 }} />
}
